import { render, staticRenderFns } from "./DamageOverview.vue?vue&type=template&id=a3567fd4&scoped=true"
import script from "./DamageOverview.vue?vue&type=script&lang=ts"
export * from "./DamageOverview.vue?vue&type=script&lang=ts"
import style0 from "./DamageOverview.vue?vue&type=style&index=0&id=a3567fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3567fd4",
  null
  
)

export default component.exports